import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const thumbnailBlogFragment = gql`
  fragment thumbnailBlog on ThumbnailBlog {
    id
    type
    status
    blogPost {
      id
      title
      subtitle
      imageUrl
      body
      slug
      author {
        firstname
      }
      createdAt
    }
  }
`

export const thumbnailBlogFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'THUMBNAIL_EVENT_COLLECTION',
    'THUMBNAIL_WITH_URL',
    'THUMBNAIL_BLOG',
    'GROUP_COLLECTION',
    'RECURRING_EVENT_COLLECTION',
    'RECOMMENDED_EVENT_COLLECTION',
  ]).isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'PREVIEW']).isRequired,
  blogPost: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    author: PropTypes.shape({
      firstname: PropTypes.string.isRequired,
    }).isRequired,
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
})

export default thumbnailBlogFragment
